import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-white scroll-mt-[72px]">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">
            {contactContent.desc}
          </p>
        </div>

        <div className="bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 flex-shrink-0">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">邮箱</p>
                <p className="text-sm text-foreground-600 mt-1">{contactContent.email}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 flex-shrink-0">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">微信</p>
                <p className="text-sm text-foreground-600 mt-1">{contactContent.wechat}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-500 flex-shrink-0">
                <i className="ri-qq-line text-xl"></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">QQ群</p>
                <p className="text-sm text-foreground-600 mt-1">{contactContent.qq}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 flex-shrink-0">
                <i className="ri-time-line text-xl"></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">工作时间</p>
                <p className="text-sm text-foreground-600 mt-1">{contactContent.workingHours}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}